<template>
  <div id="app">
    <!-- Lateral Menu -->
    <LateralMenu />
    
    <!-- Main -->
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import LateralMenu from './components/LateralMenu.vue'

export default {
  name: 'App',
  components: { LateralMenu }
}
</script>

<style>
:root {
  --mm-custom-color-4: #cf7d31;
  --mm-custom-color-5: #F7F3EE;
  --mm-custom-color-1: #282828;
  --mm-custom-color-2: #DC780F;
  --mm-custom-color-3: #5B5D62;
  --custom-color-5: #995400;
}

#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  background: var(--mm-custom-color-1);
  color: var(--mm-custom-color-5);
}

.main-content {
  padding-top: 20px;
  padding-left: 320px;
  padding-right: 20px;
  min-height: 100vh;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .main-content {
    padding-left: 20px;
  }
}

/* Bootstrap overrides for dark theme */
.btn-primary {
  background: var(--mm-custom-color-2);
  border: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  color: var(--mm-custom-color-5);
}

.btn-primary:hover {
  background: var(--custom-color-5);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
  color: var(--mm-custom-color-5);
}

.btn-outline-primary {
  border-color: var(--mm-custom-color-2);
  color: var(--mm-custom-color-2);
}

.btn-outline-primary:hover {
  background: var(--mm-custom-color-2);
  border-color: var(--mm-custom-color-2);
  color: var(--mm-custom-color-5);
}

.card {
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  background: var(--mm-custom-color-3);
  color: var(--mm-custom-color-5);
}

.card-body {
  padding: 1.5rem;
}

.alert-info {
  background: var(--mm-custom-color-4);
  border-color: var(--mm-custom-color-4);
  color: var(--mm-custom-color-5);
}

/* Dark theme overrides */
body {
  background: var(--mm-custom-color-1);
  color: var(--mm-custom-color-5);
}

h1, h2, h3, h4, h5, h6 {
  color: var(--mm-custom-color-5);
}

.text-muted {
  color: var(--mm-custom-color-3) !important;
}
</style>
